export default __webpack_public_path__ + "static/ak-cached/24h/media/Fire-Stick.23d6e94b.jpeg";